<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.contract.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="起始时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" level="4" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <!-- <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button> -->
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2"
      dialogWidth="1000px" />

    <!-- <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" /> -->
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_4'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
      sign: 'report',
      dialogTitle: '人社业务信息',

      baseInfo: [
        { key: 'province', label: '省' },
        { key: 'city', label: '市' },
        { key: 'county', label: '县' },
        { key: 'town', label: '镇' },
        { key: 'village', label: '村' },
        // { key: 'areaName', label: '地区' },

        { key: 'syncCompanyNumber', label: '同步招聘企业数量' },
        { key: 'syncJobs', label: '同步岗位数量' },
        { key: 'syncHire', label: '同步招聘会数量' },
        { key: 'syncHireJob', label: '同步招聘会岗位数量' },
      ],

      formItems: [
        { type: 'text', key: 'syncCompanyNumber', label: '同步招聘企业数量' },
        { type: 'text', key: 'syncJobs', label: '同步岗位数量' },
        { type: 'text', key: 'syncHire', label: '同步招聘会数量' },
        { type: 'text', key: 'syncHireJob', label: '同步招聘会岗位数量' },
      ],
      formItems2: null,
    }
  },
  methods: {
    getData(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R
          // this.tableData = _R.map(x => {
          //   x.areaName = x.province + x.city + x.county + x.town + x.village
          //   return x
          // })
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
    this.btnShow.search = true
    const mapList = ['export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}
</style>